module.exports = __webpack_public_path__ + "static/img/map-tooltip-bg.797c40b1.png";